/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.onboarding.tours.rpc.ToursRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getToursRpc = {
  serviceName: 'com.hubspot.onboarding.tours.rpc.ToursRpc',
  rpcName: 'getTours',
  auth: 'app',
  fingerprint: 'z8EvyfxquULaPyhCMl6-TZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTourRpc = {
  serviceName: 'com.hubspot.onboarding.tours.rpc.ToursRpc',
  rpcName: 'getTour',
  auth: 'app',
  fingerprint: 'XFbhlYtDNHmnYqNwYJI0b5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertTourRpc = {
  serviceName: 'com.hubspot.onboarding.tours.rpc.ToursRpc',
  rpcName: 'upsertTour',
  auth: 'app',
  fingerprint: 'CJhCrCOP99KOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteTourRpc = {
  serviceName: 'com.hubspot.onboarding.tours.rpc.ToursRpc',
  rpcName: 'deleteTour',
  auth: 'app',
  fingerprint: '0QhvjhiBorGOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};